<script>
import Utmify from "@/components/tools/modals/Utmify.vue";
import IntegrationList from "../IntegrationList.vue";
export default {
  extends: IntegrationList,
  data() {
    return {
      name: "Utmify",
      integration: "utmify",

      modal: Utmify,
      columns: [
        { name: "Produto", field: "product_name" },
        {
          name: "Status",
          field: "status",
          type: "tag",
          transform: this.formatStatus,
          color: this.formatStatusColor,
          size: "0.5fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ]
    };
  }
};
</script>
